import React from 'react'

export default function PostTitleParagraph({ content, isSmallerTitles }) {
  let { pretitle, title, body } = content
  body = body?.replace(/<ul>/g, `<ul class="list-primary">`)

  return (
    <section className='title-paragraph'>
      <div className='title-paragraph__container'>
        <div className='title-paragraph__card'>
          <p className='title-paragraph__pretitle'>{pretitle}</p>
          {!isSmallerTitles && (
            <h3 className='title-paragraph__title'>{title}</h3>
          )}
          {isSmallerTitles && <h4>{title}</h4>}
          <div
            className='title-paragraph__paragraph'
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </div>
      </div>
    </section>
  )
}
